import { ChatBrowserMessage, ChatTemplate } from "@/domains/chat/constants/chat";

export default function getEmoteMessageContentByTemplate(message: ChatBrowserMessage) {
  const { template, content } = message.message;

  if (template === null && content) {
    return { text: content, secured: false };
  }

  switch (template) {
    case ChatTemplate.EngineToggledOn: {
      return {
        text: "завёл двигатель",
        secured: false,
      };
    }

    case ChatTemplate.EngineToggledOff: {
      return {
        text: "заглушил двигатель",
        secured: false,
      };
    }

    case ChatTemplate.RandomDice: {
      return {
        text: `бросил кости [${message.message.payload}]`,
        secured: true,
      };
    }

    case ChatTemplate.RandomCoin: {
      return {
        text: `бросил монетку [${message.message.payload ? "орёл" : "решка"}]`,
        secured: true,
      };
    }

    case ChatTemplate.VehicleLocked: {
      return {
        text: `закрыл тачку`,
        secured: true,
      };
    }

    case ChatTemplate.VehicleUnlocked: {
      return {
        text: `открыл тачку`,
        secured: true,
      };
    }

    default: {
      return {
        text: template,
        secured: false,
      };
    }
  }
}
